<template>
  <div>
    <div
      v-if="!deleted && this.prize.deletedAt == null"
      class="flex-table-row d-flex align-items-center"
    >
      <div
        class="column c-prize-name"
        :style="{
      textDecoration: this.prize.status=='drawn' ? 'underline' : 'none',
      cursor: this.prize.status=='drawn' ? 'pointer' : 'auto'
    }"
      >{{ this.prize.name }}</div>
      <div class="column c-status">
        <div class="dropdown" v-if="!this.prize.drawn && this.prize.draws.length <= 0">
          <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">
            Start Draw
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu start-draw">
            <li>
              <button class="btn" @click="startPublicDraw()">Public</button>
            </li>
            <li>
              <button class="btn" @click="startDraw()">Private</button>
            </li>
          </ul>
        </div>
        <!-- <button v-if='!this.prize.drawn && this.prize.draws.length <= 0' class="btn btn-secondary" @click="startDraw()">Start Draw</button> -->
        <div
          v-if="!this.prize.drawn && this.prize.draws.length > 0"
          class="alert alert-secondary"
          role="alert"
        >in progress</div>
        <div v-if="this.prize.drawn" class="alert alert-success" role="alert">drawn</div>
      </div>
      <div
        class="column c-list block-with-text mobile"
        :title="this.prize.lists.map((i) => i.name).join(', ')"
      >{{ this.prize.lists.map((i) => i.name).join(', ') }}</div>
      <div class="column c-winners mobile">{{ this.prize.winnerCount }}</div>
      <!-- <div class="column c-attendees">{{ this.prize.num_of_attendees }}</div> -->
      <div class="column type-date c-created mobile">
        {{ formatDate(this.prize.createdAt) }}
        <span>{{ formatTime(this.prize.createdAt) }}</span>
      </div>
      <div class="column type-date c-modified mobile">
        {{ formatDate(this.prize.updatedAt) }}
        <span>{{ formatTime(this.prize.updatedAt) }}</span>
      </div>
      <div class="column c-modified-by mobile">
        <div>{{ this.prize.author.gevmeUser.firstname }}</div>
        <div style="margin-top: 7px;">{{ this.prize.author.gevmeUser.email }}</div>
      </div>
      <div class="column c-action">
        <div class="btn-group">
          <button
            type="button"
            class="btn dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img class="menu-vertical" src="@/assets/images/menu_vertical.svg">
          </button>
          <div class="dropdown-menu dropdown-menu-right prize-list-actions">
            <button v-if="this.prize.drawn" class="dropdown-item" @click="viewDrawSummary()">
              <img src="@/assets/images/eye.svg">
              View Draw Summary
            </button>
            <button
              v-if="!this.prize.drawn && this.prize.draws.length <= 0"
              class="dropdown-item"
              @click="editPrize()"
            >
              <img src="@/assets/images/edit.svg">
              Edit Prize
            </button>
            <button class="dropdown-item" @click="duplicatePrize()">
              <img src="@/assets/images/duplicate.svg">
              Duplicate Prize
            </button>
            <button v-if="this.prize.drawn" class="dropdown-item" @click="exportAttendees(prize)">
              <img src="@/assets/images/export.svg">
              Export Attendees
            </button>
            <button
              v-if="!this.prize.drawn && this.prize.draws.length <= 0"
              class="dropdown-item"
              @click="deleteModal()"
            >
              <img src="@/assets/images/trash.svg">
              Delete Prize
            </button>
            <button class="dropdown-item" @click="goToAuditHistory(prize.id, prize.name)">
              <img src="@/assets/images/audit-history.svg">
              Audit History
            </button>
          </div>
        </div>
      </div>
      <div :id="deleteModalId" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Are you Sure?</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <p class="cancel-warning">
                Do you want to delete the prize
                <span style="font-weight: 600">{{this.prize.name}}</span>?
              </p>
              <div class="modal-btn-container">
                <button class="btn btn-default spin" @click="dismissDeleteModal()">Cancel</button>
                <button class="btn btn-danger" @click="deletePrize()">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="deleted && this.prize.deletedAt != null"
      class="flex-table-row d-flex align-items-center"
    >
      <div
        class="column c-prize-name"
        :style="{
      textDecoration: this.prize.status=='drawn' ? 'underline' : 'none',
      cursor: this.prize.status=='drawn' ? 'pointer' : 'auto'
    }"
      >{{ this.prize.name }}</div>
      <div class="column c-status">
        <!-- <button v-if='!this.prize.drawn && this.prize.draws.length <= 0' class="btn btn-secondary" @click="startDraw()">Start Draw</button>
        <div v-if='!this.prize.drawn && this.prize.draws.length > 0' class="alert alert-secondary" role="alert">in progress</div>-->
        <div class="alert alert-danger" role="alert">Deleted</div>
      </div>
      <div
        class="column c-list block-with-text mobile"
        :title="this.prize.lists.map((i) => i.name).join(', ')"
      >{{ this.prize.lists.map((i) => i.name).join(', ') }}</div>
      <div class="column c-winners mobile">{{ this.prize.winnerCount }}</div>
      <!-- <div class="column c-attendees">{{ this.prize.num_of_attendees }}</div> -->
      <div class="column type-date c-created mobile">
        {{ formatDate(this.prize.createdAt) }}
        <span>{{ formatTime(this.prize.createdAt) }}</span>
      </div>
      <div class="column type-date c-modified mobile">
        {{ formatDate(this.prize.updatedAt) }}
        <span>{{ formatTime(this.prize.updatedAt) }}</span>
      </div>
      <div class="column c-modified-by mobile">
        <div>{{ this.prize.author.gevmeUser.firstname }}</div>
        <div style="margin-top: 7px;">{{ this.prize.author.gevmeUser.email }}</div>
      </div>
      <div class="column c-action">
        <div class="btn-group">
          <button
            type="button"
            class="btn dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img class="menu-vertical" src="@/assets/images/menu_vertical.svg">
          </button>
          <div class="dropdown-menu dropdown-menu-right prize-list-actions">
            <button v-if="this.prize.drawn" class="dropdown-item" @click="viewDrawSummary()">
              <img src="@/assets/images/eye.svg">
              View Draw Summary
            </button>
            <button class="dropdown-item" @click="duplicatePrize()">
              <img src="@/assets/images/duplicate.svg">
              Duplicate Prize
            </button>
            <button v-if="this.prize.drawn" class="dropdown-item" @click="exportAttendees(prize)">
              <img src="@/assets/images/export.svg">
              Export Attendees
            </button>
            <button class="dropdown-item" @click="goToAuditHistory(prize.id, prize.name)">
              <img src="@/assets/images/audit-history.svg">
              Audit History
            </button>
          </div>
        </div>
      </div>
      <div :id="deleteModalId" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Are you Sure?</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <p class="cancel-warning">
                Do you want to delete the prize
                <span style="font-weight: 600">{{this.prize.name}}</span>?
              </p>
              <div class="modal-btn-container">
                <button class="btn btn-default spin" @click="dismissDeleteModal()">Cancel</button>
                <button class="btn btn-danger" @click="deletePrize()">Delete</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import FullLoader from "@/components/FullLoader";
var $ = require("jquery");

const Json2csvParser = require("json2csv").Parser;

export default {
  name: "PrizeTableRow",
  data() {
    return {
      createLoading: false,
      prizeName: "",
      attendeesForExport: []
    };
  },
  components: {
    FullLoader
  },
  props: ["prize", "index", "deleted"],

  computed: {
    deleteModalId() {
      return `${this.prize.id}DeleteModal`;
    }
  },
  methods: {
    async exportAttendees(prize) {
      let eventId = localStorage.getItem("event_id");
      let filters = prize.lists
        .map(key => {
          return key.id;
        })
        .join('","');

      let convertToCSV = objArray => {
        let array =
          typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
        let str = "";
        for (let i = 0; i < array.length; i++) {
          let line = "";
          for (let index in array[i]) {
            if (line !== "") line += ",";
            line += array[i][index];
          }
          str += line + "\r\n";
        }
        return str;
      };

      let exportCSVFile = (headers, items, fileTitle, title) => {
        if (headers) {
          items.unshift(headers);
        }

        // Convert Object to JSON
        let jsonObject = JSON.stringify(items);
        let csv = title + "\r\n\n" + convertToCSV(jsonObject);
        let exportedFilenmae = fileTitle + ".csv" || "export.csv";

        let blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
          // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilenmae);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      };
      //attendeesSample
      let query = `query { attendeesFilter(eventId:"${eventId}", filterIds:["${filters}"]) }`;
      if (prize.drawn === true) {
        query = `query {
            attendeesFilter(eventId:"${eventId}", prizeId: "${
          prize.id
        }" filterIds:["${filters}"])
          }`;
      }

      try {
        let attendeeJson = await axios.post(
          ENDPOINT,
          {
            query: query
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        );

        let array = [];
        let date = new Date();
        date = `${date.getDate()}-${date.getMonth() +
          1}-${date.getFullYear()}_${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

        let attendeesFilter;

        attendeesFilter = attendeeJson.data.data.attendeesFilter;
        let listName = "";
        attendeesFilter.map(key => {
          listName = key.detail.name;
          key.attendees.map(k => {
            if (
              array.filter(person => person.attendeeId == k._id).length == 0
            ) {
              array.push({
                fname: k.firstname,
                lname: k.lastname,
                email: k.email,
                attendeeId: k._id,
                ticketId: k.ticket_no.toString(),
                list: listName
              });
            } else {
              array.filter(person => person.attendeeId == k._id)[0].list = `${
                array.filter(person => person.attendeeId == k._id)[0].list
              } | ${listName}`;
            }
          });
        });

        let headers = {
          fname: "FIRST NAME",
          lname: "LAST NAME",
          email: "EMAIL ID",
          attendeeId: "ATTENDEE ID",
          ticketId: "TICKET ID",
          list: "LIST"
        };
        let fileName =
          prize.name.replace(/ /g, "_") + "@" + date.replace(/:/g, "-");
        let title = `PRIZE NAME,${prize.name}\r\nEXPORTED ON,${date}`;
        exportCSVFile(headers, array, fileName, title);
      } catch (error) {
        console.log(error);
      }
    },

    dismissDeleteModal() {
      $("#" + this.deleteModalId).modal("hide");
    },
    deleteModal() {
      $("#" + this.deleteModalId).modal("show");
    },
    formatDate(date) {
      return moment(date).format("MMM Do 'YY");
    },
    formatTime(time) {
      return moment(time).format("h:mm A");
    },
    deletePrize() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                mutation {
                  deletePrize( prizeId: "${this.prize.id}" ) {
                    id
                  }
                }
              `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            this.createLoading = false;
            if (response.data.errors && response.data.errors.length) {
              return;
            }
            this.dismissDeleteModal();
            Event.$emit("Prize Deleted", response.data.data.deletePrize.id);
          }.bind(this)
        );
    },
    editPrize() {
      this.$router.push({
        name: "EditPrize",
        params: {
          editPrize: this.prize,
          button: "Update Prize",
          text: "Edit Prize"
        }
      });
    },
    duplicatePrize() {
      this.$router.push({
        name: "CreatePrize",
        params: {
          editPrize: this.prize,
          button: "Create Prize"
        }
      });
    },
    goToAuditHistory(prizeId, prizeName) {
      this.$router.push({
        name: "AuditHistory",
        query: {
          prizeid: prizeId,
          prizeName: prizeName
        }
      });
    },
    viewDrawSummary() {
      this.$router.push({
        name: "DrawSummary",
        params: {
          prizeInfo: this.prize
        }
      });
    },
    startDraw() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                    mutation {
                        updateDraw(status: "start", prizeId:"${this.prize.id}")
                    }
                `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            console.log("");
          }.bind(this)
        );
      this.$router.push({
        name: "PerformDraw",
        params: {
          prizeInfo: this.prize
        }
      });
    },
    startPublicDraw() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                    mutation {
                        updateDraw(status: "start", prizeId:"${this.prize.id}")
                    }
                `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            console.log("");
          }.bind(this)
        );
      this.$router.push({
        name: "PerformPublicDraw",
        params: {
          prizeInfo: this.prize
        }
      });
    }
  }
};
</script>

<style scoped>
.menu-vertical {
  width: 6px;
  height: 22px;
}

.prize-list-actions.dropdown-menu {
  left: 20px !important;
  top: 5px !important;
  font-size: 14px;
}

.prize-list-actions.dropdown-menu .dropdown-item {
  color: #5e6977;
  line-height: 1.71;
  padding: 0.25rem 0.75rem;
}

.prize-list-actions.dropdown-menu .dropdown-item:focus {
  outline: none;
}

.prize-list-actions.dropdown-menu .dropdown-item:active {
  background-color: rgba(0, 123, 255, 0.1);
}
.prize-list-actions .dropdown-item > img {
  width: 15px;
  height: 15px;
  margin-right: 7px;
  position: relative;
  bottom: 2px;
}

.prize-list-actions.dropdown-menu:before {
  position: absolute;
  top: -8px;
  right: 15px;
  display: inline-block;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ccc;
  border-left: 8px solid transparent;
  border-bottom-color: #dce3e8;
  content: "";
}

.prize-list-actions.dropdown-menu:after {
  position: absolute;
  top: -7px;
  right: 16px;
  display: inline-block;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ffffff;
  border-left: 7px solid transparent;
  content: "";
}
.header-action.modal-close {
  cursor: pointer;
}

.modal-dialog {
  margin: 10rem auto;
  max-width: 670px;
}
.modal-body {
  padding: 45px;
}

.modal-body .title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modal-body .title h2 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 35px;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
}
.dropdown-menu.start-draw {
  min-width: auto;
}

@media screen and (max-width: 991px) {
  .mobile {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PrizeTableRow.vue